import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalDocumentationRoutingModule } from './legal-documentation-routing.module';
import { LegalDocumentationComponent } from './legal-documentation.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SharedModule } from 'app/shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';

const routes: Routes = [
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
];

@NgModule({
  declarations: [
    LegalDocumentationComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
  ],
  imports: [
    CommonModule,
    LegalDocumentationRoutingModule,
    SharedModule,
    // RouterModule.forChild(routes)
  ],
})
export class LegalDocumentationModule { }
